import { render } from "./BaseQuantityAdjuster.vue?vue&type=template&id=019752c4&scoped=true"
import script from "./BaseQuantityAdjuster.vue?vue&type=script&lang=js"
export * from "./BaseQuantityAdjuster.vue?vue&type=script&lang=js"

import "./BaseQuantityAdjuster.vue?vue&type=style&index=0&id=019752c4&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019752c4"]])

export default __exports__